"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonsContainer = exports.PopTicketArrowSvg = exports.PopTicketSubmitButton = exports.PopTicketInput = exports.PopTicketField = exports.PopTicketForm = exports.PopTicketColRight = exports.PopTicketButtonWithBorder = exports.PopTicketDesc = exports.PopTicketTitle = exports.PopTicketColLeft = exports.PopTicketTwoCol = exports.PopTicket = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-around;\n  padding: 0 40px;\n  margin-top: 16px;\n\n  @media only screen and (max-width: 767px) {\n    flex-direction: column-reverse;\n\n    a:nth-child(2) {\n      margin-bottom: 16px;\n    }\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  width: 1em;\n  height: 1em;\n  transition: 0.3s;\n  margin-left: 13px;\n  fill: var(--color-brand, #fff);\n  font-size: 20px;\n\n  ", ":hover & {\n    transform: translateX(5px);\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  padding: 0 20px;\n  align-items: center;\n  background-color: transparent;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--color-brand, #fff);\n  background: var(--color-popup-ticket-button-form-bg, #000);\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  font-family: GothamPro, Arial, sans-serif;\n  font-weight: 400;\n  width: 100%;\n  display: block;\n  color: var(--color-popup-ticket-input-text, #fff);\n  background-color: var(--color-popup-ticket-input-bg, #0e100f);\n  transition: border-color 0.3s ease;\n  font-size: 16px;\n  padding: 16px 80px 16px 25px;\n\n  &::placeholder {\n    color: var(--color-popup-ticket-input-text, #fff);\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin: auto 0 0;\n  padding: 0;\n\n  @media only screen and (max-width: 1023px) {\n    border: none;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 0;\n  border-left: 1px solid var(--color-popup-ticket-border-column, #2c302d);\n  display: flex;\n  flex-direction: column;\n  padding: 40px 64px;\n  justify-content: center;\n  min-height: 330px;\n\n  @media only screen and (max-width: 1023px) {\n    padding: 40px 40px;\n  }\n\n  @media only screen and (max-width: 767px) {\n    border: none;\n    border-top: 1px solid var(--color-popup-ticket-border-column, #2c302d);\n    min-height: 0;\n    padding: 40px 0;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  max-width: 224px;\n  width: 100%;\n  margin: auto auto 0;\n  height: 50px;\n  border: 2px solid transparent;\n  color: white;\n  font-size: 14px;\n\n  &:hover {\n    background-color: var(--color-brand-hover, #fff);\n    color: #000;\n\n    &:before {\n      opacity: 0;\n    }\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    z-index: -2;\n    background: linear-gradient(\n      145deg,\n      var(--color-brand),\n      var(--color-brand-hover)\n    );\n  }\n\n  &:before {\n    transition: 0.2s;\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    z-index: -1;\n    background: var(--color-popup-ticket-button-before, #161917);\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 1.5;\n  text-align: center;\n  margin-bottom: 28px;\n\n  a {\n    color: var(--color-brand);\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 24px;\n  line-height: 1.28;\n  text-align: center;\n  margin-bottom: 28px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 0;\n  display: flex;\n  flex-direction: column;\n  padding: 40px 64px;\n  justify-content: center;\n  min-height: 330px;\n\n  @media only screen and (max-width: 1023px) {\n    padding: 40px 40px;\n  }\n\n  @media only screen and (max-width: 767px) {\n    min-height: 0;\n    padding: 40px 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  @media only screen and (max-width: 767px) {\n    flex-direction: column;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: white;\n  background: var(--color-popup-ticket-background, #131513);\n  border: 15px solid var(--color-popup-ticket-border, #5f5f5f);\n  display: inline-block;\n  margin: 0;\n  max-width: 100%;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 44px;\n  position: relative;\n  text-align: left;\n  width: 1030px;\n  padding: 80px 0;\n  z-index: 100;\n\n  @media only screen and (max-width: 1023px) {\n    padding: 50px 0;\n  }\n\n  @media only screen and (max-width: 767px) {\n    padding: 0 40px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PopTicket = _styledComponents.default.div(_templateObject());

exports.PopTicket = PopTicket;

var PopTicketTwoCol = _styledComponents.default.div(_templateObject2());

exports.PopTicketTwoCol = PopTicketTwoCol;

var PopTicketColLeft = _styledComponents.default.div(_templateObject3());

exports.PopTicketColLeft = PopTicketColLeft;

var PopTicketTitle = _styledComponents.default.p(_templateObject4());

exports.PopTicketTitle = PopTicketTitle;

var PopTicketDesc = _styledComponents.default.p(_templateObject5());

exports.PopTicketDesc = PopTicketDesc;
var PopTicketButtonWithBorder = (0, _styledComponents.default)(_styled.PopButton)(_templateObject6());
exports.PopTicketButtonWithBorder = PopTicketButtonWithBorder;

var PopTicketColRight = _styledComponents.default.div(_templateObject7());

exports.PopTicketColRight = PopTicketColRight;

var PopTicketForm = _styledComponents.default.form(_templateObject8());

exports.PopTicketForm = PopTicketForm;

var PopTicketField = _styledComponents.default.div(_templateObject9());

exports.PopTicketField = PopTicketField;

var PopTicketInput = _styledComponents.default.input(_templateObject10());

exports.PopTicketInput = PopTicketInput;

var PopTicketSubmitButton = _styledComponents.default.button(_templateObject11());

exports.PopTicketSubmitButton = PopTicketSubmitButton;

var PopTicketArrowSvg = _styledComponents.default.svg(_templateObject12(), PopTicketSubmitButton);

exports.PopTicketArrowSvg = PopTicketArrowSvg;

var ButtonsContainer = _styledComponents.default.span(_templateObject13());

exports.ButtonsContainer = ButtonsContainer;